import { Link } from "react-router-dom";

// Common layout for authentication pages
const AuthLayout = ({ children }) => (
  <main className="bg-white dark:bg-gray-900">
    <div className="relative md:flex">
      {/* Content */}
      <div className="md:w-1/2">
        <div className="min-h-[100dvh] h-full flex flex-col after:flex-1">
          {/* Header */}
          <div className="flex-1">
            <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
              {/* Logo */}
              <Link className="block" to="/">
                <img
                  src="/assets/images/logo-ppb-color.png"
                  alt="Preppinbee Logo"
                  className="h-8 object-contain"
                />
              </Link>
            </div>
          </div>

          <div className="max-w-sm mx-auto w-full px-4 py-8">{children}</div>
        </div>
      </div>

      {/* Image */}
      <div
        className="hidden md:block absolute top-0 bottom-0 right-0 md:w-1/2 bg-yellow-500"
        aria-hidden="true"
      >
        <img
          className="object-center w-full h-full"
          src="/assets/images/welcome-back-graphic.svg"
          width="760"
          height="1024"
          alt="Authentication"
        />
      </div>
    </div>
  </main>
);

export default AuthLayout;
